import React from 'react';
import { bool, func } from 'prop-types';

import { FormattedMessage } from '../../util/reactIntl';
import Button from '../Button/Button';
import { H3 } from '../Heading/Heading';
import Modal from '../Modal/Modal';
import css from './CloseListingModal.module.css';

const CloseListingModal = props => {
  const { error, isOpen, inProgress, onClose, onConfirm, onManageDisableScrolling } = props;

  return (
    <Modal
      id="CloseListingModal"
      isOpen={isOpen}
      onClose={inProgress ? () => null : onClose}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <div className={css.content}>
        <H3 as="h2">
          <FormattedMessage id="ManageListingsPage.closeConfirmationTitle" />
        </H3>
        <p>
          <FormattedMessage id="ManageListingsPage.closeConfirmationText" />
        </p>
        {error ? (
          <p className={css.error} role="alert">
            <FormattedMessage id="CloseListingModal.error" />
          </p>
        ) : null}
        <div className={css.actions}>
          <Button
            className={css.confirmButton}
            disabled={inProgress}
            inProgress={inProgress}
            onClick={onConfirm}
          >
            <FormattedMessage id="ManageListingsPage.closeConfirmationAction" />
          </Button>
          <button
            className={css.cancelButton}
            type="button"
            disabled={inProgress}
            onClick={onClose}
          >
            <FormattedMessage id="ManageListingsPage.closeConfirmationCancel" />
          </button>
        </div>
      </div>
    </Modal>
  );
};

CloseListingModal.defaultProps = {
  error: false,
  inProgress: false,
};

CloseListingModal.propTypes = {
  error: bool,
  isOpen: bool.isRequired,
  inProgress: bool,
  onClose: func.isRequired,
  onConfirm: func.isRequired,
  onManageDisableScrolling: func.isRequired,
};

export default CloseListingModal;
